import { FETCH_CUSTOMER_DETAILS_SUCCESS, FETCH_CUSTOMER_DETAILS_ERROR, FETCH_CUSTOMER_RECOMMENDATIONS_PRODUCTS, STORE_SCHEDULE_DATA, FETCH_MENU_SUCCESS, FETCH_CUSTOMER_DETAILS, UPDATE_CUSTOMER_INFO_ERROR, UPDATE_CUSTOMER_INFO, UPDATE_CUSTOMER_INFO_SUCCESS, DELETE_CUSTOMER_ACCOUNT, DELETE_CUSTOMER_ACCOUNT_SUCCESS, DELETE_CUSTOMER_ACCOUNT_ERROR, MARKETING_PREFERENCE, MARKETING_PREFERENCE_SUCCESS, MARKETING_PREFERENCE_FAILURE, RESET_CUSTOMER_INFO, UPDATE_ISNEW_CUSTOMER, } from '../../constants';
import _ from 'lodash';
import Strings from '../../constants/Strings';
import { MenuUtils } from '../../utils/MenuUtils';
const { filterCatalogByExclusionAndAvailability, createFlatList, clearMasterList } = MenuUtils;
const initialState = {
    isLoading: false,
    basic: {},
    savedAddresses: [],
    savedCards: [],
    favouriteOrders: [],
    favouriteItems: [],
    favouriteStores: [],
    pastOrders: [],
    recommendedProducts: [],
    menuResponse: null,
    flatResponse: [],
    fulfillment: {
        scheduled: {},
    },
    customerId: '',
    customerIdUpdated: false,
    isNewCustomer: false,
    accountDeleted: false,
    accountDeletionError: false,
    customerDetailsError: false,
};
const profileReducer = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_CUSTOMER_INFO:
        case FETCH_CUSTOMER_DETAILS:
        case MARKETING_PREFERENCE:
            return {
                ...state,
                isLoading: true,
                customerDetailsError: false,
            };
        case FETCH_CUSTOMER_DETAILS_SUCCESS:
            let favouriteOrders = action?.response?.customer?.favouriteOrders ?? [];
            const { customerId = '' } = state;
            let favouriteOrdersArray = favouriteOrders.filter(function (e) {
                return ((e.status !== Strings.posFailed) && e.orderTrackingNo);
            });
            let pastOrders = action?.response?.customer?.pastOrders ?? [];
            let pastOrdersArray = pastOrders.filter(function (e) {
                return ((e.status !== Strings.posFailed) && e.orderTrackingNo);
            });
            const isCustomerIdUpdated = customerId !== action?.response?.customer?.basic?.id;
            return {
                ...state,
                basic: action?.response?.customer?.basic ?? {},
                pastOrders: pastOrdersArray,
                savedAddresses: action?.response?.customer?.savedAddresses ?? [],
                savedCards: action?.response?.customer?.savedCards ?? [],
                favouriteOrders: favouriteOrdersArray,
                favouriteItems: action?.response?.customer?.favouriteItems ?? [],
                favouriteStores: action?.response?.customer?.favouriteStores ?? [],
                recommendedProducts: updatedRecommendedProducts(action?.response?.recommendedProducts ?? [], state.flatResponse),
                customerId: action?.response?.customer?.basic?.id,
                isLoading: false,
                customerIdUpdated: isCustomerIdUpdated,
                isNewCustomer: action?.response?.isNewCustomer,
                customerDetailsError: false,
            };
        case UPDATE_CUSTOMER_INFO_SUCCESS:
            return {
                ...state,
                basic: {
                    ...state.basic,
                    firstName: action.response.firstName,
                    middleName: action.response.middleName,
                    lastName: action.response.lastName,
                    email: action.response.emailId,
                    phone: action.response.phoneNumber,
                    emailId: action.response.emailId,
                    phoneNumber: action.response.phoneNumber,
                    birthYear: action.response.attributes.birthYear,
                    birthDay: action.response.attributes.birthDay,
                    birthMonth: action.response.attributes.birthMonth,
                    postalCode: action.response.attributes.postalCode,
                },
                isLoading: false,
            };
        case UPDATE_ISNEW_CUSTOMER:
            return {
                ...state,
                isNewCustomer: false,
            };
        case MARKETING_PREFERENCE_FAILURE:
        case MARKETING_PREFERENCE_SUCCESS:
            return {
                ...state,
                basic: {
                    ...state.basic,
                    marketingPreferences: action.response?.marketingPreferences
                }
            };
        case FETCH_CUSTOMER_DETAILS_ERROR:
            return {
                ...state,
                isLoading: false,
                customerDetailsError: true,
            };
        case UPDATE_CUSTOMER_INFO_ERROR: {
            return {
                ...state,
                isLoading: false,
            };
        }
        case DELETE_CUSTOMER_ACCOUNT:
            return {
                ...state,
                accountDeleted: false,
                accountDeletionError: false,
                isLoading: true,
            };
        case DELETE_CUSTOMER_ACCOUNT_SUCCESS:
            return {
                ...state,
                accountDeleted: true,
                accountDeletionError: false,
                isLoading: false,
            };
        case DELETE_CUSTOMER_ACCOUNT_ERROR:
            return {
                ...state,
                accountDeleted: false,
                accountDeletionError: true,
                isLoading: false,
            };
        case FETCH_MENU_SUCCESS: {
            const tenantDateFormat = action?.tenantDateFormat ?? '';
            return {
                ...state,
                recommendedProducts: updatedRecommendedProducts(state.recommendedProducts, action.flatResponse),
                menuResponse: action.response,
                flatResponse: action.flatResponse,
                tenantDateFormat,
            };
        }
        case RESET_CUSTOMER_INFO:
            return {
                ...state,
                basic: {},
                pastOrders: [],
                savedAddresses: [],
                savedCards: [],
                favouriteOrders: [],
                favouriteItems: [],
                favouriteStores: [],
                recommendedProducts: [],
                customerId: '',
                customerIdUpdated: false,
                isNewCustomer: false,
                accountDeleted: false,
                customerDetailsError: false,
            };
        case STORE_SCHEDULE_DATA:
            return {
                ...state,
                fulfillment: action.payload[2].fulfillment,
            };
        case FETCH_CUSTOMER_RECOMMENDATIONS_PRODUCTS:
            return {
                ...state,
                recommendedProducts: updatedRecommendedProducts(state.recommendedProducts, state.flatResponse),
            };
        default:
            return state;
    }
};
export const updatedRecommendedProducts = (recommendedProducts = [], flatResponse = {}) => {
    if (!(recommendedProducts?.length <= 0 || flatResponse?.items === null || flatResponse?.items?.length <= 0)) {
        const removalIds = [];
        for (let i = 0; i < recommendedProducts?.length; i++) {
            const recommededItemId = recommendedProducts[i]?.id || '';
            let isToBeRemoved = true;
            for (let j = 0; j < flatResponse?.items?.length && isToBeRemoved; j++) {
                if (recommededItemId === flatResponse?.items[j]?.id) {
                    let tempItem = Object.assign({}, _.cloneDeep(recommendedProducts[i]));
                    recommendedProducts[i] = { ...flatResponse?.items[j], ...tempItem };
                    isToBeRemoved = false;
                    continue;
                }
            }
            if (isToBeRemoved) {
                removalIds.push(recommededItemId);
            }
        }
        recommendedProducts =
            recommendedProducts &&
                recommendedProducts?.length &&
                recommendedProducts?.filter((item) => {
                    for (let i = 0; i < removalIds?.length; i++) {
                        if (item?.id === removalIds[i]) {
                            return false;
                        }
                    }
                    return true;
                });
    }
    return recommendedProducts;
};
export default profileReducer;
